import {axiosPrivate} from "../axios-config/axiosPrivate";
import {standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";

export const getMandantenJobs = ({parameters}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/mandantenjobs`, {
        ...standardRequestConfig
        , params: parameters
    })
}

export const deleteMandantenJobs = ({parameters}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/mandantenjobs`, {
        ...standardRequestConfig
        , params: parameters
    })
}